module.exports = __webpack_public_path__ + "img/companion-market-overview-category.9b8b9d11.png";